// extracted by mini-css-extract-plugin
module.exports = {"hidden":"routerLoader_hidden__23fOj","visible":"routerLoader_visible__1W594","block":"routerLoader_block__1U-qP"};